export enum CallUsReason {
  Plan = 'plan',
  PlanNotFound = 'planNotFound',
  ZipCode = 'zipCode',
  RecommendationError = 'recommendationError',
  MaPlan = 'maPlan',
  DSNP = 'dsnp',
}
